import { jsx, jsxs } from "react/jsx-runtime";
import {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { Flex } from "antd";
import FixturesApi from "./../../api/FixturesApi.js";
import Loader from "./../../components/loader/Loader.js";
import HeaderTabs from "./../../components/tabComponents/HeaderTabs.js";
import TabsTabItems from "./../../components/tabComponents/TabsTabItems.js";
import { withScrollToTop } from "./../../hoc";
import useTabItems from "./../../hook/useTabItems.js";
import { useParams } from "react-router-dom";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import { Components } from "./fixtureContent/fixtureContentService";
import FixtureDetailsHeader from "./fixtureDetailsHeader/FixtureDetailsHeader";
const API_CALL_TIMEOUT = 3e3;
const FixtureDetails = () => {
  var _a, _b, _c, _d, _e;
  const { id } = useParams();
  const getFixtureDetailsApi = FixturesApi.getFixtureDetails();
  const getFixtureLiveContextApi = FixturesApi.getFixtureLiveContext();
  const [fixtureDetails, setFixtureDetails] = useState(null);
  const [liveContext, setLiveContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const tabItems = useMemo(
    () => {
      var _a2;
      return (_a2 = fixtureDetails == null ? void 0 : fixtureDetails.tabItems) != null ? _a2 : [];
    },
    [fixtureDetails]
  );
  const {
    items,
    activeTabKey,
    activeTabData,
    tabsActiveTabId,
    setActiveTabKey,
    setTabsActiveTabId
  } = useTabItems({ tabItems });
  const Component = useMemo(
    () => {
      var _a2;
      return (_a2 = Components[activeTabKey]) != null ? _a2 : Loader;
    },
    [activeTabKey]
  );
  const timerRef = useRef();
  const needUpdate = useMemo(
    () => {
      var _a2;
      return ((_a2 = liveContext == null ? void 0 : liveContext.timeState) == null ? void 0 : _a2.toLowerCase()) !== "ft";
    },
    [liveContext]
  );
  useEffect(() => {
    setLoading(true);
    getFixtureDetails(id);
    getFixtureLiveContext(id);
    return () => {
      getFixtureDetailsApi.cancel();
      getFixtureLiveContextApi.cancel();
      clearTimeout(timerRef.current);
    };
  }, [id]);
  const getFixtureDetails = async (id2) => {
    try {
      const response = await getFixtureDetailsApi.call(id2);
      setFixtureDetails(response.data);
    } catch (error) {
      console.error("Error fetching fixture details:", error);
    } finally {
      setLoading(false);
    }
  };
  const getFixtureLiveContext = async (id2) => {
    var _a2;
    clearTimeout(timerRef.current);
    try {
      const response = await getFixtureLiveContextApi.call(id2);
      setLiveContext(response.data);
      if (((_a2 = response.data.timeState) == null ? void 0 : _a2.toLowerCase()) !== "ft") {
        timerRef.current = setTimeout(() => {
          getFixtureLiveContext(id2);
        }, API_CALL_TIMEOUT);
      }
    } catch (error) {
      console.error("Error fetching fixture live context:", error);
    }
  };
  const fixtureDetailsHomeAway = useMemo(() => {
    const { home, away } = (fixtureDetails == null ? void 0 : fixtureDetails.fixtureItem) || {};
    return { home, away };
  }, [fixtureDetails]);
  const videoClickCallback = useCallback(() => {
    track(EVENT_ACTIONS.VIDEO_FROM_MATCHES);
  }, []);
  return (!liveContext || loading) && !fixtureDetails ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsxs(
    Flex,
    {
      vertical: true,
      gap: 24,
      className: "fixture-details",
      style: {
        position: "relative"
      },
      children: [
        loading && /* @__PURE__ */ jsx(Loader, { overlay: true }),
        /* @__PURE__ */ jsx(
          FixtureDetailsHeader,
          {
            fixtureDetails,
            liveContext,
            children: /* @__PURE__ */ jsx(
              HeaderTabs,
              {
                items,
                activeTabKey,
                setActiveTabKey
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 16, children: [
          /* @__PURE__ */ jsx(
            TabsTabItems,
            {
              activeTabData,
              tabItemId: tabsActiveTabId,
              setTabsActiveTabId,
              radioStyleType: "secondary"
            }
          ),
          /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, {}), children: /* @__PURE__ */ jsx(
            Component,
            {
              data: activeTabData,
              tabItemId: tabsActiveTabId,
              needUpdate,
              fixtureId: id,
              fixtureDetailsHomeAway,
              seasonId: fixtureDetails == null ? void 0 : fixtureDetails.seasonId,
              venue: fixtureDetails == null ? void 0 : fixtureDetails.venue,
              groupId: fixtureDetails == null ? void 0 : fixtureDetails.groupId,
              homeId: (_b = (_a = fixtureDetails == null ? void 0 : fixtureDetails.fixtureItem) == null ? void 0 : _a.home) == null ? void 0 : _b.id,
              awayId: (_d = (_c = fixtureDetails == null ? void 0 : fixtureDetails.fixtureItem) == null ? void 0 : _c.away) == null ? void 0 : _d.id,
              videoClickCallback,
              leagueIconUrl: (_e = fixtureDetails == null ? void 0 : fixtureDetails.leagueInfo) == null ? void 0 : _e.iconUrl
            }
          ) })
        ] })
      ]
    }
  );
};
var stdin_default = withScrollToTop(FixtureDetails);
export {
  stdin_default as default
};
